import React, { Fragment, Component } from "react"
import Card from "components/card/course-card"
import ProgressCard from "components/common/ProgressCard"
import CertificateCard from "./CertificateCard"
import { ContentLoader } from "./Loader"

// Import styles
import "styles/components/common/card-list.scss"

class CardList extends Component {
  renderCard(data, type, isFeatured) {
    switch (type) {
      case "progress":
        return (
          <Fragment>
            {data &&
              data.map((item) => <ProgressCard data={item} key={item.id} />)}
          </Fragment>
        )
      case "certificate":
        return (
          <Fragment>
            {data &&
              data.map((item) => <CertificateCard data={item} key={item.id} />)}
          </Fragment>
        )
      case "bundle":
        return (
          <Fragment>
            {data &&
              data.map((item) => (
                <Card data={item} key={item.id} isBundle={true} />
              ))}
          </Fragment>
        )
      default:
        return (
          <Fragment>
            {data &&
              data.map((item) => (
                <Card
                  data={item}
                  key={item.id}
                  isBundle={item.type === "bundle"}
                  isFeatured={isFeatured}
                />
              ))}
          </Fragment>
        )
    }
  }

  render() {
    const { data, loading, type, isFeatured = false } = this.props
    return loading ? (
      <div className="loading-wrapper">
        <ContentLoader loading={loading} />
      </div>
    ) : (
      <div className="card-album">
        {this.renderCard(data, type, isFeatured)}
      </div>
    )
  }
}

export default CardList
